exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container.change-pass {\r\n    width: 100%;\r\n    max-width: 500px;\r\n    padding: 32px;\r\n}\r\n\r\n    .container.change-pass .input-group {\r\n        padding-bottom: 24px;\r\n    }\r\n\r\n    .container.change-pass button {\r\n        width: auto;\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n    }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/login/resetpassword.component.css
// module id = ../../../../../client/app/shared/login/resetpassword.component.css
// module chunks = main